export default {
  id: '7b052532ee',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=NASCET><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Back</span></a></div><div class=title>NASCET Index</div></div></div><div class=page-content><div class="block block-strong no-hairlines-md margin-top-half"><p><b>Sonographic NASCET Index of ICA:</b></p><dl><dt>&lt;15% stenosis</dt><dd>deceleration spectral broadening with a peak systolic velocity (PSV) &lt;125 cm/s</dd><dt>16-49% stenosis</dt><dd>pansystolic spectral broadening with a PSV &lt;125 cm/s</dd><dt>50-69% stenosis</dt><dd>pansystolic spectral broadening with a PSV of &lt;125 cm/s</dd><dd><i>and</i></dd><dd>diastolic velocity (EDV) &lt;110 cm/s or ICA/CCA PSV ratio &gt;2 but &lt;4</dd><dt>70-79% stenosis</dt><dd>pansystolic spectral broadening with PSV &gt;270 cm/s or EDV &gt;110 cm/s or ICA/CCA PSV ratio &gt;4</dd><dt>80-99% stenosis</dt><dd>EDV &gt;140 cm/s</dd><dt>complete occlusion</dt><dd>no flow; terminal thumps</dd></dl></div></div></div>';
      return r;
    }(this);
  },

  styleScoped: false
};